export { RecsModule } from './recs.component';
